import { render, staticRenderFns } from "./ResumenCompras.vue?vue&type=template&id=21290d84&scoped=true"
import script from "./ResumenCompras.vue?vue&type=script&lang=js"
export * from "./ResumenCompras.vue?vue&type=script&lang=js"
import style0 from "./ResumenCompras.vue?vue&type=style&index=0&id=21290d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21290d84",
  null
  
)

export default component.exports